<div class="report-header-left">
   <ng-content select="ndt-report-output-image"></ng-content>
   <ng-content select="ndt-report-output-lcs-contact-info"></ng-content>
   <ng-content select="ndt-report-output-header"></ng-content>
   <ng-content select="ndt-report-output-date"></ng-content>
</div>
<div class="report-header-center"><ng-content select="[center]"></ng-content> </div>
<div class="report-header-right">
   <div class="flex-container">
      <ng-content select="ndt-report-parameter-list"></ng-content>
      <ng-content select="ndt-register-print-summary"></ng-content>
   </div>
   <ng-content></ng-content>
</div>
